/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Follow_StatusInputs */

const en_follow_status = /** @type {(inputs: Follow_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow status`)
};

/**
* | output |
* | --- |
* | "Follow status" |
*
* @param {Follow_StatusInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const follow_status = /** @type {((inputs?: Follow_StatusInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Follow_StatusInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_follow_status(inputs)
});